import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ResponsableTipoSelect from "./ResponsableTipoSelect.js"

import Select from 'react-select';
import 'react-select/dist/react-select.css';

import {Row, Col, Label, Input, InputGroup,FormFeedback} from 'reactstrap';
class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            empresa: null,
            tipo: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    setSelects(data) {
        this.setState({
            empresa: data.empresa_id,
            tipo: data.tipo_id,
        });
    }

    render() {
        return (
            <ParadigmaModal 
                getUrl={api.clientes.responsables.edit} 
                postUrl={api.clientes.responsables.edit} 
                onSubmit={() => this.props.onSubmit()}  
                id={this.props.id} 
                successMessage={"El Contacto ha sido editado con éxito."} 
                missingIdMessage={"Debe seleccionar una fila."} 
                title={"Editar Contacto"} 
                buttonTitle={"Editar Contacto"}
                buttonIcon={"fa fa-pencil fa-lg"} 
                 
                saveButton={true} 
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}>
                <Row>
                    <Col className="col-6">
                        <Label>Nombre</Label>
                        <Input type="text" name="nombre"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                    <Col className="col-6">
                        <Label>Apellido</Label>
                        <Input type="text" name="apellido"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row>
                    <Col className="col-12">
                        <Label>Empresa</Label>
                        <ParadigmaAsyncSeeker fieldName={"empresa_id"} url={api.clientes.empresas.select} value={this.state.empresa}/>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                    <Col className="col-8">
                        <Label>Tipo</Label>
                        <ParadigmaAsyncSeeker value={this.state.tipo} fieldName={"tipo_id"} multiselect={true} url={api.clientes.tiporesponsables.select}/>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                    <Col className="col-4">
                        <Label>Teléfono</Label>
                        <Input type="text" name="telefono"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row>
                    <Col className="col-12">
                        <Label>Email</Label>
                        <Input type="text" name="email"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
                <Row>
                    <Col className="col-12">
                        <Label>Observaciones</Label>
                        <Input type="textarea" name="observaciones" />
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/clientes/Responsables/Edit.js